import { render } from "./subscribe_form.vue?vue&type=template&id=24bc1b7a"
import script from "./subscribe_form.vue?vue&type=script&lang=js"
export * from "./subscribe_form.vue?vue&type=script&lang=js"
script.render = render

export default script